import React,{useState,useEffect} from "react";
import { Building2, Calendar, ChevronRight, Mail, Phone, Rocket, X,User } from "lucide-react";
import { Link } from "react-router-dom";
import PaymentModal from "../CashfreePaymentModal";
import { initializePayment } from "../../utils/paymentUtils";
import toast from "react-hot-toast";

import { PaymentType } from '../../utils/paymentTypes'
import { saveStartupIdea } from "../../utils/api";
const StartupIdeaPage = () => {
      const [isModalOpen, setIsModalOpen] = useState(false)
      const [currentStep, setCurrentStep] = useState(1)
 const [formData, setFormData] = useState({
 
  name: "",
  email: "",
  phone: "",

 
  cityState: "",
  currentRole: "",

  
  hasStartupExperience: "",
  startupExperienceDetails: "",
  ideaEngineReason: "",
  interestedDomain: "",

  
  buildingInSixMonths: "",
  biggestChallenge: "",
  skills: "",
  willingToExecute: "",
  lookingForCofounders: "",
  linkedInProfile: "",

  declarationAccepted: false,
  programType: "startup-idea",
})
  const [isSubmitting, setIsSubmitting] = useState(false)

  const [processing, setProcessing] = useState(false);
  const [paymentSessionId, setPaymentSessionId] = useState(null);
  const [currentOrderId, setCurrentOrderId] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);


  const handleSubmit = async (e) => {
   console.log("Form data",formData)
    setProcessing(true);

    try {
      // 1. Validate inputs
      if (!formData.name || !formData.phone || !formData.email) {
        toast.error("Please fill all required fields");
        setProcessing(false);
        return;
      }

      // 2. Store registration temp data (same as events)
      sessionStorage.setItem(
        "startup_session_booking",
        JSON.stringify({
          ...formData,
          amount: 2000,

        })
      );

      const token = localStorage.getItem("Startuptoken");

      // 3. Initialize Payment (same function your events use)
      const payment = await initializePayment({
        type: PaymentType.STARTUP_IDEAS,  // reuse event payment logic
        amount: 2000,
        token,
        returnUrl: `${window.location.origin}/payment-callback`,
      });

      const payload={...formData,paymentOrderId:payment.order_id}


      setFormData({...formData, name: "",
  email: "",
  phone: "",

 
  cityState: "",
  currentRole: "",

  
  hasStartupExperience: "",
  startupExperienceDetails: "",
  ideaEngineReason: "",
  interestedDomain: "",

  
  buildingInSixMonths: "",
  biggestChallenge: "",
  skills: "",
  willingToExecute: "",
  lookingForCofounders: "",
  linkedInProfile: "",

  declarationAccepted: false,
  programType: "startup-idea",})
setCurrentStep(1)
      // 4. Extract session + order id and show modal
      setPaymentSessionId(payment?.payment_session_id);
      setCurrentOrderId(payment?.order_id);
      setShowPaymentModal(true);
toast.success(res.message)
    } catch (error) {
      console.error("Payment error:", error);
      toast.error(error.message || "Payment failed");
    } finally {
        
      setProcessing(false);
    }
  };
  return (
    <>
    <section className="py-10 px-6 md:px-20">
            <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
    
              {/* LEFT CONTENT */}
              <div className="order-2 md:order-1">
                <h2 className="text-4xl font-extrabold text-gray-900 mb-6">
                  What is the TACTOS <br /><span className="text-[#fd3e3d]">Idea Engine?</span>
                </h2>
    
                <p className="text-gray-700 text-lg max-w-xl leading-relaxed mb-10 text-justify">
                Idea Engine is TACTOS’ curated innovation vault - a collection of actionable
              business insights, structured opportunities, and validated frameworks
              available for aspiring entrepreneurs.
                </p>
                <div className="text-center">
                  <button
                    onClick={() => setIsModalOpen(true)}
                    className="inline-flex items-center gap-3 bg-[#fd3e3d] hover:bg-[#e63635] text-white font-semibold py-4 px-10 rounded-xl shadow-lg hover:shadow-xl transition w-full justify-center"
                  >
                    Apply Now
                    <ChevronRight className="w-5 h-5" />
                  </button>
                </div>
    
    
              </div>
    
              {/* RIGHT IMAGE */}
              <div className="order-1 md:order-2 flex justify-center md:justify-end">
                <img
                  src="/tactosideaenginepageimage.jpg"
                  alt="Bootcamp"
                  className="rounded-xl w-full max-w-md"
                />
              </div>
    
            </div>
          </section>
      

      

      {/* -------------------------------------- */}
      {/* HOW IT WORKS – Arrow Flow */}
      {/* -------------------------------------- */}
      <section className="py-10 bg-gray-50">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-5">
          HOW IT <span className="text-[#fd3e3d]">WORKS</span>
        </h2>

        <div className="space-y-2 max-w-6xl mx-auto px-4 md:px-8">

          {/* Row 1 - 3 Steps */}
          <div className="flex flex-col md:flex-row justify-center gap-6">

            {[
              [
                "Register Now",
                "Get early access to TACTOS’ curated Innovation Vault."
              ],
              [
                "Screening / Proving",
                "Showcase your entrepreneurial mindset and hunger to build."
              ],
              [
                "Your Calling",
                "Receive a validated, actionable business opportunity."
              ]
            ].map(([title, desc], i,arr) => (
              <div 
                key={i}
                className="relative w-full md:w-[32%] border p-6 rounded-xl  shadow-sm"
              >
                <h3 className="text-xl font-bold mb-2">{title}</h3>
                <p className="text-gray-700 text-sm leading-relaxed">{desc}</p>

                {/* Red Arrow */}
                {i !== arr.length - 1 && (
        <div
          className="hidden md:block absolute right-[-25px] top-1/2 -translate-y-1/2
          w-0 h-0 border-t-[25px] border-b-[25px] border-l-[25px] border-transparent
          border-l-[#fd3e3d] drop-shadow-md"
        ></div>
      )}
              </div>
            ))}

          </div>
        </div>
      </section>




      {/* -------------------------------------- */}
      {/* WHAT YOU WILL GET */}
      {/* -------------------------------------- */}
      <section className="py-10 ">
       <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-5">
         WHAT YOU <span className="text-[#fd3e3d]"> WILL GET</span>?
        </h2>
        <div className="container mx-auto max-w-6xl px-4 md:px-8 grid md:grid-cols-3 gap-10">

          {[
            [
              "A Clear Problem Statement",
              [
                "Each Idea Engine concept comes with a sharply defined, researchbacked problem worth solving. We provide clarity on why the problem exists, who faces it, and how big the opportunity is. Founders instantly know exactly what challenge they are building for"
              ],
            ],
            [
              "A Business Plan",
              [
                "Every curated idea includes a foundational business plan to kickstart your journey. We break down the model, revenue logic, market size, and operational needs. Founders get a ready-to-use blueprint they can refine and build on immediately.",
              ],
            ],
            [
              "Strategy",
              [
                "Idea Engine offers a pre-built strategic direction for each concept. From competitive positioning to goto-market pathways, the core strategy is already mapped. You start with a clear advantage - a strategy that’s structured, actionable, and scalable.",
              ],
            ],
            [
              "Execution Plan",
              [
                "No more guessing what to do next - each idea comes with a step-bystep execution flow. We outline phases, priorities, and milestones to move from idea → prototype → launch. Founders gain an execution-ready roadmap that removes confusion and accelerates progress.",
              ],
            ],
            [
              "Defined Target Customer",
              [
                "Each curated idea includes wellresearched customer segments and early adopters. We highlight user needs, pain points, behaviour patterns, and purchase readiness. You begin with crystal-clear clarity on who you’re building for and why they will care",
              ],
            ],
            [
              "Validated Startup Idea",
              [
                "Every Idea Engine concept is vetted through trends, market data, and global benchmarks. Founders don’t start from zero - they start with ideas that already show demand signals. You get a validated, high-potential startup idea that reduces risk and increases success odds",
              ],
            ],
          ].map(([title, bullets], i) => (
            <div 
              key={i}
              className="border rounded-xl p-6 shadow-sm hover:shadow-lg transition"
            >
              <h4 className="font-bold text-lg mb-3">{title}</h4>

              <ul className="text-gray-600 space-y-2 text-sm leading-relaxed">
                {bullets.map((b, index) => (
                  <li key={index}>{b}</li>
                ))}
              </ul>

            </div>
          ))}

        </div>
      </section>


      {/* -------------------------------------- */}
      {/* APPLY CTA */}
      {/* -------------------------------------- */}
      <section className="py-10">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-6">
            Ready to Access Your <span className="text-[#fd3e3d]">Startup Idea?</span>
          </h2>

          <button
           onClick={() => setIsModalOpen(true)}
            className="inline-flex items-center gap-3 bg-[#fd3e3d] hover:bg-[#e63635] text-white font-semibold py-4 px-10 rounded-xl shadow-lg transition"
          >
            Apply Now
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </section>
      
     {/* {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setIsModalOpen(false)} />

          <div className="relative w-full max-w-md rounded-2xl overflow-hidden shadow-2xl bg-white animate-in fade-in zoom-in-95 duration-200">
           
            <div className="bg-black p-6 text-center relative">
              <button
                onClick={() => setIsModalOpen(false)}
                className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors"
              >
                <X className="w-6 h-6" />
              </button>
              <div className="flex justify-center mb-3">
                <div className="bg-[#fd3e3d] p-3 rounded-full">
                  <Calendar className="w-8 h-8 text-white" />
                </div>
              </div>
              <h3 className="text-white text-2xl font-bold">Book Your Session</h3>
              <p className="text-white/70 text-sm mt-1">Connect with a mentor who fits your needs</p>
             
              <div className="flex flex-col items-center gap-1 mt-4">
                <div className="flex items-center gap-2">
                  <span className="text-white/60 text-sm">Pay now:</span>
                  <span className="text-[#fd3e3d] text-xl font-bold">₹2,000</span>
                  <span className="text-xs bg-white/10 text-white/80 px-2 py-1 rounded-full">First Session</span>
                </div>
                <span className="text-white/40 text-xs">Remaining ₹23,000 payable after first session</span>
              </div>
            </div>

           
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-black/40" />
                <input
                  type="text"
                  placeholder="Your Name"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full pl-11 pr-4 py-3 rounded-xl border border-black/20 focus:border-[#fd3e3d] focus:ring-2 focus:ring-[#fd3e3d]/20 focus:outline-none transition-all text-black placeholder:text-black/40"
                />
              </div>

              <div className="relative">
                <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-black/40" />
                <input
                  type="tel"
                  placeholder="Phone Number"
                  required
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="w-full pl-11 pr-4 py-3 rounded-xl border border-black/20 focus:border-[#fd3e3d] focus:ring-2 focus:ring-[#fd3e3d]/20 focus:outline-none transition-all text-black placeholder:text-black/40"
                />
              </div>

              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-black/40" />
                <input
                  type="email"
                  placeholder="Email Address"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full pl-11 pr-4 py-3 rounded-xl border border-black/20 focus:border-[#fd3e3d] focus:ring-2 focus:ring-[#fd3e3d]/20 focus:outline-none transition-all text-black placeholder:text-black/40"
                />
              </div>

              <div className="relative">
                <Building2 className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-black/40" />
                <input
                  type="text"
                  placeholder="Startup Name (if any)"
                  value={formData.startupName}
                  onChange={(e) => setFormData({ ...formData, startupName: e.target.value })}
                  className="w-full pl-11 pr-4 py-3 rounded-xl border border-black/20 focus:border-[#fd3e3d] focus:ring-2 focus:ring-[#fd3e3d]/20 focus:outline-none transition-all text-black placeholder:text-black/40"
                />
              </div>

             
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#fd3e3d] hover:bg-[#e63635] disabled:opacity-70 disabled:cursor-not-allowed text-white font-semibold py-4 px-6 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 mt-2"
              >
                {isSubmitting ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    Processing...
                  </>
                ) : (
                  <>
                    <Rocket className="w-5 h-5" />
                    Pay ₹2,000 & Book Session
                  </>
                )}
              </button>

              <p className="text-center text-black/40 text-xs">
                Secure payment. A mentor will reach out within 24 hours
              </p>
            </form>
          </div>
        </div>
      )} */}

      {isModalOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
    <div
      className="absolute inset-0 bg-black/60 backdrop-blur-sm"
      onClick={() => setIsModalOpen(false)}
    />

    <div className="relative w-full max-w-xl max-h-[98vh] rounded-2xl overflow-hidden shadow-2xl bg-white flex flex-col">

      {/* HEADER */}
      <div className="bg-black p-6 text-center relative">
        <button
          onClick={() => setIsModalOpen(false)}
          className="absolute top-4 right-4 text-white/80 hover:text-white"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="flex justify-center mb-3">
          <div className="bg-[#fd3e3d] p-3 rounded-full">
            <Calendar className="w-8 h-8 text-white" />
          </div>
        </div>

       

         <h3 className="text-white text-2xl font-bold">Book Your Session</h3>
              <p className="text-white/70 text-sm mt-1">Connect with a mentor who fits your needs</p>
             
              <div className="flex flex-col items-center gap-1 mt-4">
                <div className="flex items-center gap-2">
                  <span className="text-white/60 text-sm">Pay now:</span>
                  <span className="text-[#fd3e3d] text-xl font-bold">₹2,000</span>
                  <span className="text-xs bg-white/10 text-white/80 px-2 py-1 rounded-full">First Session</span>
                </div>
                <span className="text-white/40 text-xs">Remaining ₹23,000 payable after first session</span>
              </div>
      </div>

      {/* STEPPER */}
      <div className="px-6 py-6">
        <div className="flex items-center justify-between relative">
          <div className="absolute top-1/2 left-0 w-full h-[2px] bg-gray-300 -translate-y-1/2" />
          <div
            className="absolute top-1/2 left-0 h-[2px] bg-[#fd3e3d] -translate-y-1/2 transition-all duration-500"
            style={{ width: `${((currentStep - 1) / 3) * 100}%` }}
          />
          {[1, 2, 3, 4].map(step => (
            <div key={step} className="relative z-10">
              <div
                className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold
                  ${currentStep >= step ? "bg-[#fd3e3d] text-white scale-110" : "bg-gray-200 text-gray-500"}
                `}
              >
                {step}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FORM */}
      <form className="p-6 space-y-5 overflow-y-auto max-h-[60vh]">

        {/* STEP 1 – BASIC INFORMATION */}
       {currentStep === 1 && (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

    <div>
      <label className="text-sm text-black/70">Name</label>
      <input
        value={formData.name}
        onChange={e => setFormData({ ...formData, name: e.target.value })}
        placeholder="Full Name"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">Email</label>
      <input
        value={formData.email}
        onChange={e => setFormData({ ...formData, email: e.target.value })}
        placeholder="Email"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">Phone Number</label>
      <input
        value={formData.phone}
        onChange={e => setFormData({ ...formData, phone: e.target.value })}
        placeholder="Phone Number"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">City and State</label>
      <input
        value={formData.cityAndState}
        onChange={e => setFormData({ ...formData, cityAndState: e.target.value })}
        placeholder="City and State"
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div className="md:col-span-2">
      <label className="text-sm text-black/70">
        Current Role (Student / Working / Founder)
      </label>
      <select
        value={formData.currentRole}
        onChange={e => setFormData({ ...formData, currentRole: e.target.value })}
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      >
        <option value="">Select Role</option>
        <option>Student</option>
        <option>Working Professional</option>
        <option>Founder</option>
      </select>
    </div>

  </div>
)}


        {/* STEP 2 – STARTUP / ENTREPRENEURIAL BACKGROUND */}
       {currentStep === 2 && (
  <div className="grid grid-cols-1 gap-4">

    <div>
      <label className="text-sm text-black/70">
        Have you tried building a startup or product before?
      </label>
      <select
        value={formData.hasStartupExperience}
        onChange={e =>
          setFormData({ ...formData, hasStartupExperience: e.target.value })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      >
        <option value="">Yes / No</option>
        <option>Yes</option>
        <option>No</option>
      </select>
    </div>

    <div>
      <label className="text-sm text-black/70">
        If yes, describe briefly (2–3 lines)
      </label>
      <textarea
        value={formData.startupExperienceDetails}
        onChange={e =>
          setFormData({ ...formData, startupExperienceDetails: e.target.value })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">
        Why do you want access to the Tactos Idea Engine? (max 80 words)
      </label>
      <textarea
        value={formData.ideaEngineReason}
        onChange={e =>
          setFormData({ ...formData, ideaEngineReason: e.target.value })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">
        Interested Domain
      </label>
      <select
        value={formData.interestedDomain}
        onChange={e =>
          setFormData({ ...formData, interestedDomain: e.target.value })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      >
        <option value="">Select Domain</option>
        <option>AI</option>
        <option>Consumer Tech</option>
        <option>FinTech</option>
        <option>HealthTech</option>
        <option>EdTech</option>
        <option>Climate</option>
        <option>Mobility</option>
        <option>SaaS</option>
        <option>Other</option>
      </select>
    </div>

  </div>
)}


        {/* STEP 3 – INTENT & SKILLS */}
      {currentStep === 3 && (
  <div className="grid grid-cols-1 gap-4">

    <div>
      <label className="text-sm text-black/70">
        Are you actively looking to build a startup in the next six months?
      </label>
      <select
        value={formData.buildingInSixMonths}
        onChange={e =>
          setFormData({ ...formData, buildingInSixMonths: e.target.value })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      >
        <option value="">Yes / No</option>
        <option>Yes</option>
        <option>No</option>
      </select>
    </div>

    <div>
      <label className="text-sm text-black/70">
        Biggest challenge stopping you right now
      </label>
      <input
        value={formData.biggestChallenge}
        onChange={e =>
          setFormData({ ...formData, biggestChallenge: e.target.value })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">
        Skills you bring (technical, business, design, etc.)
      </label>
      <input
        value={formData.skills}
        onChange={e => setFormData({ ...formData, skills: e.target.value })}
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

    <div>
      <label className="text-sm text-black/70">
        Willing to validate & execute an idea?
      </label>
      <select
        value={formData.willingToExecute}
        onChange={e =>
          setFormData({ ...formData, willingToExecute: e.target.value })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      >
        <option value="">Yes / No</option>
        <option>Yes</option>
        <option>No</option>
      </select>
    </div>

    <div>
      <label className="text-sm text-black/70">
        Looking for co-founders?
      </label>
      <select
        value={formData.lookingForCofounders}
        onChange={e =>
          setFormData({ ...formData, lookingForCofounders: e.target.value })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      >
        <option value="">Yes / No</option>
        <option>Yes</option>
        <option>No</option>
      </select>
    </div>

    <div>
      <label className="text-sm text-black/70">LinkedIn Profile</label>
      <input
        value={formData.linkedInProfile}
        onChange={e =>
          setFormData({ ...formData, linkedInProfile: e.target.value })
        }
        className="w-full px-4 py-3 rounded-xl border border-black/20"
      />
    </div>

  </div>
)}

        {/* STEP 4 – DECLARATION */}
        {currentStep === 4 && (
          <label className="flex items-start gap-3 text-sm text-black/60">
            <input type="checkbox" checked={formData.declarationAccepted} onChange={e => setFormData({...formData, declarationAccepted: e.target.checked})} />
            I confirm that the information provided is accurate. I am applying to TACTOS Idea Engine with the intention to learn, execute, and participate in structured startup building.
          </label>
        )}

        {/* NAVIGATION */}
        <div className="flex justify-between pt-4">
          {currentStep > 1 && (
            <button type="button" onClick={() => setCurrentStep(s => s - 1)} className="px-4 py-2 border rounded-lg">
              Back
            </button>
          )}

         <div className="ml-auto flex gap-3">
    {/* NEXT BUTTON */}
    {currentStep < 4 && (
      <button
        type="button"
        onClick={() => setCurrentStep(s => s + 1)}
        className="px-6 py-2 bg-[#fd3e3d] text-white rounded-lg"
      >
        Next
      </button>
    )}

    {/* SUBMIT BUTTON */}
    {currentStep === 4 && (
      <button
      onClick={handleSubmit}
                type="button"
                disabled={isSubmitting}
                className="w-full bg-[#fd3e3d] hover:bg-[#e63635] disabled:opacity-70 disabled:cursor-not-allowed text-white font-semibold py-2 px-6 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 mt-2"
              >
                {isSubmitting ? (
                  <>
                    <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                    Processing...
                  </>
                ) : (
                  <>
                    <Rocket className="w-5 h-5" />
                    Pay ₹2,000 & Book Session
                  </>
                )}
              </button>
    )}
  </div>
        </div>

      </form>
    </div>
  </div>
)}

      {showPaymentModal && (
        <PaymentModal
          paymentSessionId={paymentSessionId}
          orderId={currentOrderId}
          onSuccess={() => {
            toast.success("Payment successful!");
            setShowPaymentModal(false);
            setIsModalOpen(false);
          }}
          onFailure={(error) => {
            toast.error(error.message || "Payment failed");
            setProcessing(false);
          }}
          onClose={() => {
            setShowPaymentModal(false);
            setProcessing(false);
          }}
        />
      )}
    </>

    
  );
};

export default StartupIdeaPage;
